import { render, staticRenderFns } from "./TotalResult.vue?vue&type=template&id=07c2449c"
import script from "./TotalResult.vue?vue&type=script&lang=ts"
export * from "./TotalResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports